// src/context/DrawerContext.js
import React, { createContext, useState, useContext, useMemo } from 'react';

// Create a context with an initial state
const DrawerContext = createContext(null);

export const DrawerProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerSection, setDrawerSection] = useState('default');
  const [drawerOptions, setDrawerOptions] = useState({});

  const openDrawer = (section, options = {}) => {
    setDrawerSection(section);
    setDrawerOptions(options);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const value = useMemo(() => ({
    drawerOpen,
    drawerSection,
    drawerOptions,
    openDrawer,
    closeDrawer,
  }), [drawerOpen, drawerSection, drawerOptions]);

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};

// Create a custom hook to use the drawer
export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};